import { Button, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import styles from "./styles.module.css";

const text = (
  <>
    <p className={styles.info_text}>
      Copie os dados do “Responsável pela Empresa” para o passo atual.
    </p>
  </>
);

const BtnImportarDados = ({ step, dataForm, setDataForm }) => {
  const handleImport = () => {
    const documento =
      dataForm.responsavelEmpresa.tipoDocumento === "CPF"
        ? dataForm.responsavelEmpresa.documento
        : "";
    switch (step) {
      case 3:
        setDataForm({
          ...dataForm,
          responsavelFinanceiro: {
            ...dataForm.responsavelFinanceiro,
            nome: dataForm.responsavelEmpresa.nome,
            cpf:dataForm.responsavelEmpresa.cpf,
            tipoDocumento:dataForm.responsavelEmpresa.tipoDocumento,
            documento:dataForm.responsavelEmpresa.documento,
            email: dataForm.responsavelEmpresa.email,
            telefone: dataForm.responsavelEmpresa.telefone,
            whatsapp: dataForm.responsavelEmpresa.whatsapp,
          },
        });
        break;
      case 4:
        setDataForm({
          ...dataForm,
          responsavelLegal: {
            ...dataForm.responsavelLegal,
            nome: dataForm.responsavelEmpresa.nome,
            cpf: dataForm.responsavelEmpresa.cpf,
            tipoDocumento:dataForm.responsavelEmpresa.tipoDocumento,
            documento:dataForm.responsavelEmpresa.documento,
            email: dataForm.responsavelEmpresa.email,
            telefone: dataForm.responsavelEmpresa.telefone,
            whatsapp: dataForm.responsavelEmpresa.whatsapp,
          },
        });
        break;
      case 5:
        setDataForm({
          ...dataForm,
          dadosProcurador: {
            ...dataForm.dadosProcurador,
            nome: dataForm.responsavelEmpresa.nome,
            cpf: dataForm.responsavelEmpresa.cpf,
            tipoDocumento:dataForm.responsavelEmpresa.tipoDocumento,
            documento:dataForm.responsavelEmpresa.documento,
            email: dataForm.responsavelEmpresa.email,
            telefone: dataForm.responsavelEmpresa.telefone,
            whatsapp: dataForm.responsavelEmpresa.whatsapp,
          },
        });
        break;

      default:
        break;
    }
  };

  return (
    <div>
      <Button
        variant="outlined"
        className={styles.btnImport}
        onClick={handleImport}
      >
        Copiar Dados
      </Button>
      <span className={styles.info}>
        <Tooltip
          title={
            <>
              <p>{text}</p>
            </>
          }
          placement="right-start"
          arrow
          disableFocusListener
          enterTouchDelay={100}
        >
          <InfoIcon />
        </Tooltip>
      </span>
    </div>
  );
};

export default BtnImportarDados;
